import { SimpleGrid, Divider } from '@mantine/core';
import { CustomTextInput } from '../../CustomInputFields/CustomTextInput/CustomTextInput';
import { CustomRadioGroup } from '../../CustomInputFields/CustomRadioGroup/CustomRadioGroup';
import { ProjectCardFormProps, ProjectCardFormValues } from '../ProjectCardForm.model';
import classes from '../ProjectCardForm.module.css';

export const ProjectApprovalsForm = ({
  form,
  disabled
}: Pick<ProjectCardFormProps, 'form'> & { disabled?: boolean }) => {
  const { setFieldValue, values } = form;
  const clearResolutions = (updatedValues: ProjectCardFormValues) => {
    if (updatedValues.projectPreparationApproval === false) {
      setFieldValue('projectPreparationResolution', '');
    }
    if (updatedValues.otherTypeApproval === false) {
      setFieldValue('otherTypeResolution', '');
    }
    if (updatedValues.financialApproval === false) {
      setFieldValue('financialApprovalResolution', '');
    }
  };

  const handleApprovalChange = (fieldName: keyof ProjectCardFormValues, val: boolean) => {
    setFieldValue(fieldName, val);
    const updatedValues = { ...values, [fieldName]: val };
    clearResolutions(updatedValues);
  };

  return (
    <>
      <Divider my={5} />
      <div className={classes.pageBreak} />
      <SimpleGrid cols={2} spacing="xs">
        <CustomRadioGroup
          disabled={disabled}
          label="Schválení projektové přípravy"
          options={[
            { label: 'ANO', value: true },
            { label: 'NE', value: false }
          ]}
          value={form.values.projectPreparationApproval}
          onChange={(val) => handleApprovalChange('projectPreparationApproval', val === 'true')}
          inline
        />
        <CustomTextInput
          label="Usnesení schválení projektové přípravy"
          inputProps={form.getInputProps('projectPreparationResolution')}
          disabled={!form.values.projectPreparationApproval || disabled}
        />
      </SimpleGrid>

      <SimpleGrid cols={2} spacing="xs">
        <CustomRadioGroup
          disabled={disabled}
          label="Schválení ostatní/jiného typu"
          options={[
            { label: 'ANO', value: true },
            { label: 'NE', value: false }
          ]}
          value={form.values.otherTypeApproval}
          onChange={(val) => handleApprovalChange('otherTypeApproval', val === 'true')}
          inline
        />
        <CustomTextInput
          label="Usnesení související s projektem"
          inputProps={form.getInputProps('otherTypeResolution')}
          disabled={!form.values.otherTypeApproval || disabled}
        />
      </SimpleGrid>

      <SimpleGrid cols={2} spacing="xs">
        <CustomRadioGroup
          disabled={disabled}
          label="Schválení závazného finančního příslibu"
          options={[
            { label: 'ANO', value: true },
            { label: 'NE', value: false }
          ]}
          value={form.values.financialApproval}
          onChange={(val) => handleApprovalChange('financialApproval', val === 'true')}
          inline
        />
        <CustomTextInput
          label="Usnesení závazného finančního příslibu"
          inputProps={form.getInputProps('financialApprovalResolution')}
          disabled={!form.values.financialApproval || disabled}
        />
      </SimpleGrid>
    </>
  );
};
